import { render, staticRenderFns } from "./card-evaluation.vue?vue&type=template&id=20838ebf&"
import script from "./card-evaluation.vue?vue&type=script&lang=js&"
export * from "./card-evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports